<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="refund">
			<div class="fixation">
				<div class="product">
					<div class="line" v-for="item in list">
						<div class="radio">
							<div class="radioIn" :data-id="item.id" @click="choose"><img v-show="item.select" src="../../assets/cart/duigou.png" alt="" :data-id="item.id"></div>
						</div>
						<div class="avatar">
							<img :src="item.avatar" alt="">
						</div>
						<div class="info">
							<div class="name">
								{{item.name}}
							</div>
							<div class="price">
								¥{{item.price}}
							</div>
						</div>
					</div>
				</div>
				<div class="type">
					<div class="title">选择类别</div>
					<div class="chooseBox">
						<div class="chooseItem">
							<div class="cRadio">
								<div class="cRadioIn" @click="check"><img v-show="reback" src="../../assets/cart/duigou.png" alt=""></div>
							</div>
							<div class="cWord">
								仅退款
							</div>
						</div>
						<div class="chooseItem">
							<div class="cRadio">
								<div class="cRadioIn" @click="check"><img v-show="!reback" src="../../assets/cart/duigou.png" alt=""></div>
							</div>
							<div class="cWord">
								退货退款
							</div>
						</div>
					</div>
				</div>
				<div class="rePrice">
					<div class="title">退款金额</div>
					<div class="inputBox">¥{{refundPrice}}</div>
				</div>
				<div class="remark">
					<div class="title">退款说明</div>
					<div class="remarkArea">
						<textarea placeholder="请填写您要退款的原因" v-model="reason"></textarea>
					</div>
				</div>
				<div class="upload">
					<div class="title">
						上传凭证<br>
						<span>(最多三张)</span>
					</div>
					<div class="uploadArea">
						<div class="uploadItem" v-for="item in imglist">
							<img :src="item.url" alt="">
							<div class="delete"><img src="../../assets/index/close.png" alt="" @click="deleteThisImg" :data-id="item.id"></div>
						</div>
						<div class="uploadBtn">
							<img src="../../assets/person/upload.jpg" alt="">
							<input type="file" accept="image/*" @change="handleFile">
						</div>
					</div>
				</div>
				<div class="enter">
					<div class="title"></div>
					<div class="enterBtn">
						<button @click="enter">
							确认提交申请
						</button>
					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	// your script
	export default {
		name: 'refund',
		components:{
			Head,Foot
		},
		data(){
			return {
				list:[],
				imglist:[],
				refundPrice:"0.00",
				reback:true,
				reason:""
			}
		},
		methods:{
			deleteThisImg(e){
				var id = e.target.dataset.id
				var imglist = this.imglist
				for (var i = 0; i < imglist.length; i++) {
					var iid = imglist[i].id
					if(id==iid){
						imglist.splice(i,1)
					}
				}
				this.imglist = imglist
			},
			fetchData(){
				var data = {
					method: "order.details",
					order_id: this.oid,
					token: this.token
				}
				var that = this
				this.request(data,function(res){
					if(res.status){
						var reList = res.data.items
						for (var i = 0; i < reList.length; i++) {
							var item = reList[i]
							var obj = {
								id:item.id,
								select:false,
								avatar:item.image_url,
								name:item.name,
								price:item.amount,
								nums:item.nums
							}
							that.list.push(obj)
						}
					}else{
						that.globalTest('order.details','error',res.msg,res.data)
					}
				})
			},
			choose(e){
				var id = e.target.dataset.id
				var list = this.list
				for (var i = 0; i < list.length; i++) {
					var lid = list[i].id
					if(id==lid){
						var status = list[i].select
						if(status){
							list[i].select = false
						}else{
							list[i].select = true
						}
					}
				}
				this.list = list
				this.sumPrice()
			},
			sumPrice(){
				var list = this.list
				var refundPrice = 0
				for (var i = 0; i < list.length; i++) {
					var status = list[i].select
					if(status){
						refundPrice+=parseFloat(list[i].price)
					}
				}
				this.refundPrice = refundPrice
			},
			check(){
				var reback = this.reback
				if(reback){
					this.reback = false
				}else{
					this.reback = true
				}
			},
			handleFile(e){
				let $target = e.target || e.srcElement
				let file = $target.files[0]
				var token = this.token
				var imglist = this.imglist
				if(imglist.length>=3){
					this.globalTest('images.upload','error','最多只能上传3张')
					return
				}
				var formData = new FormData()
				formData.append('image',file,file.name)
				formData.append('method','images.upload')
				formData.append('type','image')
				formData.append('token',token)
				var that = this
				this.uploadFile(formData,function(res){
					console.log(res)
					if(res.status){
						that.globalTest('images.upload','success','上传图片成功')
						var obj = {
							"id":res.data.image_id,
							"url":res.data.url
						}
						imglist.push(obj)
						that.imglist = imglist
					}else{
						that.globalTest('images.upload','error',res.msg,res.data)
					}
				})
			},
			enter(){
				var that = this
				var type = function(){
					if(that.reback){
						return 1
					}else{
						return 2
					}
				}
				var items = function(){
					var list = that.list
					var arr = new Array()
					for (var i = 0; i < list.length; i++) {
						var status = list[i].select
						if(status){
							var obj = {
								"id":list[i].id,
								"nums":list[i].nums
							}
							arr.push(obj)
						}
					}
					return arr
				}
				var img = function(){
					var imglist = that.imglist
					var arr = new Array()
					for (var i = 0; i < imglist.length; i++) {
						arr.push(imglist[i].id)
					}
					return arr
				}
				var data = {
					method:"order.addaftersales",
					order_id:this.oid,
					token:this.token,
					reason:this.reason,
					refund:this.refundPrice,
					type:type(),
					images:img(),
					items:items()
				}
				this.request(data,function(res){
					console.log(res)
					if(res.status){
						that.globalTest('order.addaftersales','success','提交退款成功')
						that.$router.push({path:'/person/order',query:{mid:1}})
					}else{
						that.globalTest('order.addaftersales','error',res.msg,res.data)
					}
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.oid = this.$route.query.oid
			this.token = localStorage.getItem('token')
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.refund{
		width: 100%;
	}
	.fixation{
		background: #FFFFFF;
		padding: 50px;
		box-sizing: border-box;
	}
	.product{
		width: 100%;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.line{
		width: 100%;
		height: 110px;
		border-bottom: 1px solid #C3C3C3;
	}
	.line:last-child{
		border-bottom: none;
	}
	.radio{
		width: 30px;
		height: 100%;
		float: left;
	}
	.radioIn{
		width: 20px;
		height: 20px;
		border: 1px solid #B3B3B3;
		box-sizing: border-box;
		border-radius: 50%;
		overflow: hidden;
		margin: 45px auto;
	}
	.radio img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.avatar{
		width: 110px;
		height: 100%;
		float: left;
	}
	.avatar img{
		width: 100px;
		height: 100px;
		display: block;
		margin: 5px auto;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
	}
	.info{
		width: 958px;
		height: 100%;
		float: left;
	}
	.info .name{
		width: 100%;
		height: 72px;
		line-height: 24px;
	}
	.info .price{
		width: 100%;
		height: 38px;
		line-height: 38px;
		color: red;
	}
	.type,.rePrice,.remark,.upload,.enter{
		width: 100%;
		position: relative;
		margin-top: 15px;
	}
	.title{
		width: 120px;
		height: 50px;
		position: absolute;
		left: 0px;
		top:0px;
		line-height: 50px;
		font-size: 16px;
	}
	.chooseBox,.inputBox,.remarkArea,.uploadArea,.enterBtn{
		width: 100%;
		padding-left: 120px;
		box-sizing: border-box;
	}
	.chooseBox{
		width: 100%;
		height: 50px;
	}
	.chooseItem{
		width: 150px;
		height: 100%;
		float: left;
		line-height: 50px;
	}
	.chooseItem .cRadio{
		width: 40px;
		height: 100%;
		float: left;
	}
	.chooseItem .cRadioIn{
		width: 20px;
		height: 20px;
		border: 1px solid #B3B3B3;
		border-radius: 50%;
		box-sizing: border-box;
		margin: 15px auto;
	}
	.cRadioIn img{
		width: 100%;
		height: 100%;
		display: block;
	}
	.inputBox{
		height: 50px;
		line-height: 50px;
		color: red;
		font-size: 16px;
	}
	.remarkArea{
		padding-top: 10px;
		box-sizing: border-box;
		height: 150px;
	}
	.remarkArea textarea{
		width: 700px;
		height: 100%;
		background: #F6F6F6;
	}
	.upload .title{
		line-height: 24px;
	}
	.upload .title span{
		color: 14px;
		color: #036DEE;
	}
	.uploadArea{
		padding-left: 110px;
	}
	.uploadItem,.uploadBtn{
		width: 140px;
		height: 110px;
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		border: 1px solid #C3C3C3;
		box-sizing: border-box;
		margin-left: 10px;
		position: relative;
	}
	.uploadItem img,.uploadBtn img{
		width: 100%;
		height: 100%;
	}
	.delete{
		width: 16px;
		height: 16px;
		position: absolute;
		right: 0px;
		top: 0px;
		z-index: 9;
	}
	.delete img{
		width: 100%;
		height: 100%;
	}
	.uploadBtn input{
		width: 100%;
		height: 100%;
		display: block;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 10;
		opacity: 0;
	}
	.enterBtn{
		height: 80px;
		padding-top: 40px;
		box-sizing: border-box;
	}
	.enterBtn button{
		width: 150px;
		height: 40px;
		border: none;
		background: #036DEE;
		color: #FFFFFF;
		border-radius: 3px;
	}
</style>
